import React from 'react';
import { cn } from '../../src/lib/utils';
type EyebrowProps = {
  children: React.ReactNode;
  className?: string;
  withDot?: boolean;
};
export function Eyebrow({
  children,
  className,
  withDot = true
}: EyebrowProps) {
  return <p className={cn('inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.09em] text-text-tertiary', className)} data-id="element-493" data-mp="2j0gtuo3ej2a4">
      {withDot ? <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-lime" data-id="element-494" data-mp="2swk0o7977p3e" /> : null}
      {children}
    </p>;
}